module.exports = __webpack_public_path__ + "static/media/col-character.feef058d.png";